import { render } from "./counsel.vue?vue&type=template&id=cc01a7b2&scoped=true&ts=true"
import script from "./counsel.vue?vue&type=script&lang=ts&config=true"
export * from "./counsel.vue?vue&type=script&lang=ts&config=true"

import "./counsel.vue?vue&type=style&index=0&id=cc01a7b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc01a7b2"]])

export default __exports__